import { render, staticRenderFns } from "./WeServeWarningDialog.vue?vue&type=template&id=b8bf9936&scoped=true&"
import script from "./WeServeWarningDialog.vue?vue&type=script&lang=js&"
export * from "./WeServeWarningDialog.vue?vue&type=script&lang=js&"
import style0 from "./WeServeWarningDialog.vue?vue&type=style&index=0&id=b8bf9936&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bf9936",
  null
  
)

export default component.exports